import {toast} from "react-toastify";
import {GET_NICE_FORM_DATA_API} from "../constants/api_constants";
import {getFetcher} from "../utils/fetcher";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {MAIN_PAGE, MAIN_PAGE_TEMP, SIGNUP_PAGE} from "../constants/page_constants";
import {RiArrowLeftSLine} from "react-icons/ri";
import {accountInfo} from "../constants/constants";

const NiceAuthPage = () => {
  const navigate = useNavigate();
  // 기존 고객은 메인으로, 신규 고객은 회원가입으로 분기 타기
  const link = accountInfo.isLogin() ? MAIN_PAGE_TEMP : SIGNUP_PAGE;

  useEffect(() => {
    loadNiceAuth();
  }, []);

  const loadNiceAuth = async () => {
    try {
      const returnUrl = `${window.location.origin}/nice-callback`;

      // 백엔드에서 나이스 정보 받기
      const res = await getFetcher().get(GET_NICE_FORM_DATA_API, {
        params: { returnUrl },
      });

      if (res.data?.result) {
        const { encData, integrityValue, tokenVersionId } = res.data.result.data;

        // 동적으로 폼 생성 후 제출
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
        form.target = 'niceAuthFrame'; // iframe 타겟 설정

        form.innerHTML = `
          <input type="hidden" id="m" name="m" value="service"/>
          <input type="hidden" name="token_version_id" value="${tokenVersionId}" />
          <input type="hidden" name="enc_data" value="${encData}" />
          <input type="hidden" name="integrity_value" value="${integrityValue}" />
        `;

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      } else {
        toast.error('본인인증 정보를 불러오는 데 실패했습니다.');
        navigate(link);
      }
    } catch (error) {
      console.error('나이스 인증 로드 에러:', error);
      toast.error('본인인증 정보를 불러오는 데 실패했습니다.');
      navigate(link);
    }
  };

  const handleGoBack = () => {
    navigate(link);
  };

  return (
      <div className="flex flex-col h-screen w-full items-center">
        <div className="flex flex-col w-full h-full max-w-md">
          {/* 상단 헤더바 (뒤로가기 버튼 포함) */}
          <header className="w-full bg-white border-b border-gray-200 h-14">
            <div className="flex items-center justify-between px-2 h-full">
              <button
                  className="flex items-center text-gray-700 font-bold"
                  onClick={handleGoBack}
              >
                <RiArrowLeftSLine className="w-6 h-auto"/>
                <span>돌아가기</span>
              </button>

              <div className="font-bold">본인인증</div>
              <div className="w-14"></div>
            </div>
          </header>

          {/* 나이스 인증 iframe */}
          <div className="flex-1 w-full">
            <iframe
                name="niceAuthFrame"
                title="나이스 본인인증"
                className="w-full h-full border-none"
            />
          </div>
        </div>
      </div>
  );
};

export default NiceAuthPage;